<template>
  <div :class="sectionClasses">
    <slot />
  </div>
</template>
<script lang="ts" setup>
import type { Padding } from '~/sanity/types';
const props = defineProps<{ padding?: Padding }>();
const paddingTop = computed(() => props.padding?.paddingTop);
const paddingBottom = computed(() => props.padding?.paddingBottom);
const paddingTopClass = computed(() => {
  return paddingTopClasses[paddingTop.value ?? 'default'] ?? paddingTopClasses['default'];
});
const paddingBottomClass = computed(() => {
  return paddingBottomClasses[paddingBottom.value ?? 'default'] ?? paddingBottomClasses['default'];
});
const sectionClasses = computed(() => [
  'padding-wrapper h-full',
  paddingTopClass.value,
  paddingBottomClass.value,
]);
const paddingTopClasses: Record<string, string> = {
  default: 'pt-10',
  '20px': 'pt-4',
  '80px': 'pt-20',
  '0px': 'pt-0',
};
const paddingBottomClasses: Record<string, string> = {
  default: 'pb-10',
  '20px': 'pb-4',
  '80px': 'pb-20',
  '0px': 'pb-0',
};
</script>
<style></style>
